import styles from './ScoopDivider.module.scss'

/**
 * ScoopDivider - A visual separator for content sections
 *
 * @component
 * @param {Object} props - Component props
 * @param {'horizontal' | 'vertical'} [props.orientation='horizontal'] - Divider orientation
 * @param {'full' | 'middle' | 'inset'} [props.variant='full'] - How the divider is inset from the edges
 *   - full: Divider spans the full width/height
 *   - middle: Small margins on both sides
 *   - inset: Margin on the start side only
 * @param {string} [props.className] - Additional CSS classes
 * @param {Object} [props.style] - Inline styles (highest priority)
 * @param {...any} props - All other props are passed to the native HTML element
 */
export const ScoopDivider = ({
    orientation = 'horizontal',
    variant = 'full',
    className = '',
    style,
    ...props
}) => {
    const dividerClassName = [styles.divider, styles[orientation], styles[variant], className]
        .filter(Boolean)
        .join(' ')

    return (
        <hr
            className={dividerClassName}
            style={style}
            role="separator"
            aria-orientation={orientation}
            {...props}
        />
    )
}

export default ScoopDivider
